import {
  ChartBarIcon,
  EyeIcon,
  ListBulletIcon,
  PencilSquareIcon,
} from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';
import { timestampFormatter } from '../../../transforms';
import RcLink from '../../RcLink/RcLink';
import SelectMenu from '../../SelectMenu/SelectMenu';
import SelectMenuItem from '../../SelectMenu/SelectMenuItem';
import ShowStatus from '../ShowStatus/ShowStatus';
import ShowHeaderSection from './ShowHeaderSection';

function ShowHeader({
  actions = null,
  badges = null,
  title,
  name,
  state = null,
  active = null,
  editTo = null,
  listTo = null,
  metricsTo = null,
  showTo = null,
  showActions = true,
  upcaseHeader = false,
  imageUrl = null,
  imageAlt = null,
  datePlaced = null,
  projectedDeliveredAt = null,
  legacyId = null,
  importOrderType = null,
  partner = null,
  total = null,
  courtesyOrder = false,
}) {
  return (
    <header className="relative isolate z-10">
      <div className="mx-auto rounded-lg bg-white/90 p-4 shadow-xs">
        <div className="mx-auto flex max-w-2xl flex-col items-center justify-between gap-x-8 sm:flex-row lg:mx-0 lg:max-w-none">
          <div className="flex flex-col items-center gap-x-8 sm:flex-row sm:items-start">
            <div className="flex items-center gap-x-8">
              {imageUrl && (
                <div className="shrink-0">
                  <img
                    src={imageUrl}
                    alt={imageAlt}
                    className="size-16 object-contain object-center"
                  />
                </div>
              )}

              <ShowHeaderSection
                label={title}
                textContent={name}
                upcaseHeader={upcaseHeader}
              />
            </div>

            {partner && (
              <ShowHeaderSection
                label="Partner Location"
                textContent={
                  <RcLink
                    to={`/partners/locations/${partner.id}`}
                    textSize="text-lg"
                    textColor="text-black hover:text-rcprimary-400"
                  >
                    {partner.name}
                  </RcLink>
                }
              />
            )}

            {datePlaced && (
              <ShowHeaderSection
                label="Date Placed"
                textContent={timestampFormatter(datePlaced)}
              />
            )}

            {projectedDeliveredAt && (
              <ShowHeaderSection
                label="Projected Delivery"
                textContent={timestampFormatter(projectedDeliveredAt, false)}
              />
            )}

            {total !== null && total !== undefined && (
              <ShowHeaderSection
                label="Total"
                textContent={
                  <span className="flex items-center gap-x-4">
                    <span>{`$${(total / 100).toFixed(2)}`}</span>
                    {courtesyOrder && <ShowStatus state="Courtesy Order" />}
                  </span>
                }
              />
            )}
          </div>

          <div className="mt-4 flex items-center gap-x-4 sm:mt-0 sm:gap-x-6">
            {legacyId && <ShowStatus state="1.0 Import" />}
            {legacyId && importOrderType && (
              <ShowStatus state={importOrderType} />
            )}
            {(state || active) && <ShowStatus state={state} active={active} />}
            {badges && <div className="mr-2">{badges}</div>}
            {showActions && (
              <SelectMenu>
                <div className="py-1">
                  {editTo && (
                    <SelectMenuItem to={editTo} icon={PencilSquareIcon}>
                      Edit
                    </SelectMenuItem>
                  )}
                  {metricsTo && (
                    <SelectMenuItem to={metricsTo} icon={ChartBarIcon}>
                      Metrics
                    </SelectMenuItem>
                  )}
                  {showTo && (
                    <SelectMenuItem to={showTo} icon={EyeIcon}>
                      Details
                    </SelectMenuItem>
                  )}
                  {listTo && (
                    <SelectMenuItem to={listTo} icon={ListBulletIcon}>
                      Back To List
                    </SelectMenuItem>
                  )}
                  {showTo && (
                    <SelectMenuItem to={showTo} icon={EyeIcon}>
                      Details
                    </SelectMenuItem>
                  )}
                </div>

                {actions}
              </SelectMenu>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

ShowHeader.propTypes = {
  actions: PropTypes.node,
  badges: PropTypes.node,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  state: PropTypes.string,
  active: PropTypes.bool,
  editTo: PropTypes.string,
  listTo: PropTypes.string,
  showActions: PropTypes.bool,
  upcaseHeader: PropTypes.bool,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  datePlaced: PropTypes.string,
  projectedDeliveredAt: PropTypes.string,
  legacyId: PropTypes.string,
  importOrderType: PropTypes.string,
  partner: PropTypes.object,
  total: PropTypes.number,
  courtesyOrder: PropTypes.bool,
};

export default ShowHeader;
